.units {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-lg);
}

.unit {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-sm);
}

.unitLabel {
  font-size: var(--mantine-font-size-sm);
  font-weight: 600;
  color: var(--adl-text-primary);
}

.measurementRow {
  display: flex;
  flex-wrap: wrap;
  gap: var(--mantine-spacing-xl);
}

.commodityCard {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-sm);
  background: var(--adl-surface-background);
  border: 1px solid var(--adl-border-light);
  border-radius: var(--mantine-radius-sm);
  padding: var(--mantine-spacing-md);
}

.commodityLabel {
  font-size: var(--mantine-font-size-sm);
  font-weight: 600;
  color: var(--adl-text-primary);
}

.commodities {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-sm);
}
